import Exam from '../../../../../core/components/templates/Exam/Main';

import ContentLoader from 'react-content-loader';
import Container from '../../../../../core/components/atoms/Container';
import { usePracticeEnemExamHook } from '../../../hooks/Enem/exam';
import ExamInfo from '../../../../../core/components/templates/Exam/Info';
import { Breadcrumbs } from '../../../../../core/components/organism/Breadcrumbs';
import NoContent from '../../../../../core/components/templates/NoContent';
import { formatDayDuration } from '../../../utils/enemDay';

const PracticeEnemExam = () => {
  const {
    data,
    day,
    isError,
    exercises,
    examTimeLeft,
    isLoading,
    isStarting,
    isFinishing,
    showExamInfo,
    foreignLanguage,
    hasForeignLanguageChoice,
    breadCrumbsItems,
    setForeignLanguage,
    updateExercise,
    startExam,
    finishExam,
  } = usePracticeEnemExamHook();

  // Erro antes do loading: na ordem inversa, uma falha da API ficava presa no
  // esqueleto e a tela de erro nunca era alcançada.
  if (isError) {
    return (
      <div className='bg-color-lighter min-h-screen w-full md:mb-0'>
        <NoContent url={`/simulados/enem`} />
      </div>
    );
  }

  if (isLoading) {
    return (
      <Container>
        <ContentLoader
          backgroundColor={'#a7adba'}
          foregroundColor={'#c0c5ce'}
          viewBox='0 0 500 30'
        >
          <rect x='0' y='2' rx='2' ry='2' width='100' height='15' />
        </ContentLoader>
        <ContentLoader
          backgroundColor={'#a7adba'}
          foregroundColor={'#c0c5ce'}
          viewBox='0 0 500 80'
        >
          <rect x='0' y='2' rx='2' ry='2' width='100%' height='70' />
        </ContentLoader>
        {Array.from({ length: 5 }, (_, index) => (
          <ContentLoader
            key={`${index}_loader`}
            backgroundColor={'#a7adba'}
            foregroundColor={'#c0c5ce'}
            viewBox='0 0 500 24'
          >
            <rect x='0' y='2' rx='2' ry='2' width='100%' height='20' />
          </ContentLoader>
        ))}
      </Container>
    );
  }

  return (
    <div className='bg-color-lighter min-h-screen w-full md:mb-0'>
      <Container className='pb-0 xl:pb-0'>
        <Breadcrumbs items={breadCrumbsItems} />
      </Container>
      {showExamInfo ? (
        <ExamInfo
          name={data?.simulated.name}
          totalQuestions={data?.simulated.questionQuantity}
          day={day}
          durationLabel={formatDayDuration(
            data?.simulated.days?.find((item) => item.day === day)
              ?.durationInMinutes ?? null
          )}
          showForeignLanguageChoice={hasForeignLanguageChoice}
          foreignLanguage={foreignLanguage}
          onForeignLanguageChange={setForeignLanguage}
          isStarting={isStarting}
          onStartExam={() => startExam()}
        ></ExamInfo>
      ) : (
        <Exam
          isMegaSimulation={data?.simulated.slug.includes('mega')}
          type='enem'
          day={day}
          provaPdfUrl={data?.simulated.provaPdfUrl}
          examName={data?.simulated.name}
          exercises={exercises}
          timeLeft={examTimeLeft}
          isLoading={isFinishing}
          onExerciseChange={(exercise) => updateExercise(exercise)}
          onFinishExam={(isTimeExpired) => finishExam(isTimeExpired)}
        />
      )}
    </div>
  );
};

export default PracticeEnemExam;
